export default __webpack_public_path__ + "static/media/head_to_head_rivalries_2.469e4129.png";